import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {ConsultationModel} from '../../../api/model/consultation.model';



@Injectable({providedIn: 'root'})
export class ConsultationRepository extends AbstractRepositoryV2<ConsultationModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Consultation', serviceElementsFactory, injector);
    }
}
